import React from "react";
import SignIn from "./SignIn";
import SignUp from "./SignUp";

function SignInAndSignUp() {
  return (
    <div>
      <SignIn />
      <SignUp />
    </div>
  );
}

export default SignInAndSignUp;
